import TomSelect from 'tom-select'
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {

    static values = {
        url: String,
        plugins: {type: Array, default: ['caret_position', 'remove_button']},
        create: true,
        preload: 'focus',
    }

    connect(event) {
        if (this.element.tagName === 'SELECT') {
            this.dropDown(this.element)
        }
    }

    checkAllBox(event) {
        let checkBoxs = this.CheckBoxs()
        checkBoxs.forEach((checkbox) => {
            if (this.element.checked === true) {
                checkbox.checked = this.element.checked
            } else {
                checkbox.checked = this.element.checked
            }
        });
        this.checkBoxClick()
    }

    checkBoxClick() {
        let accountIds = Array()
        let accountTypes = Array()
        let checkboxes = this.CheckBoxs();
        let dataModal = this.DataModal()
        let createBtn = document.getElementsByClassName("ungrouped_create_btn")

        checkboxes.forEach((checkbox) => {
            if (checkbox.checked === true) {
                accountIds.push({
                    id: checkbox.value,
                    klass: checkbox.dataset.klass
                })
                accountTypes.push(checkbox.dataset.type)

            }
        });
        let dataIdsSize = accountIds.length

        if (dataIdsSize >= 1) {
            dataModal.classList.remove("hidden")
        } else {
            this.closeModal()
        }
        let error = document.getElementsByClassName('ungrouped_errors')

        if (accountTypes.includes("BS") && accountTypes.includes(("PL"))) {
            createBtn[0].classList.add("hidden")
            error[0].classList.remove("hidden")
        } else {
            // let filter = document.getElementById("ungrouped_filter")
            // if (accountTypes.includes("BS")) {
            //     filter.setAttribute("value", "Show Only BS")
            // }
            // if (accountTypes.includes("PL")) {
            //     filter.setAttribute("value", "Show Only P&L")
            // }
            error[0].classList.add("hidden")
            createBtn[0].classList.remove("hidden")
        }
        const accountsJson = JSON.stringify(accountIds)

        dataModal.getElementsByClassName("ungrouped_level")[0].innerHTML = "Group " + dataIdsSize + " accounts under:"
        document.getElementById('ungrouped_ids').setAttribute("value", accountsJson)
    }


    dropDown(currentElement) {
        let selectedKeys = this.selectedKeys()


        let firstLevel = currentElement.id === "ungrouped_level_0"
        let url = this.setUrl(selectedKeys, firstLevel, currentElement)
        this.tomSelect(url, currentElement)

        let nextElement = this.setNextElement(currentElement)
        if (nextElement !== null && nextElement !== '') {
            this.dropDown(nextElement)
        }
    }

    nextElement(event) {
        let nextElement = this.setNextElement(this.element)
        if (nextElement === null || nextElement === undefined) {

        } else {
            this.dropDown(nextElement)
        }
    }

    setNextElement(element) {
        let currentElement = element
        let childId = currentElement.getAttribute('child_id') || ''
        return document.getElementById(childId)
    }


    tomSelect(url, currentElement) {
        if (url !== undefined && url !== '' && currentElement.tomselect !== undefined && currentElement !== '' && currentElement !== null && currentElement !== undefined && currentElement.tagName === 'SELECT') {
            currentElement.tomselect.destroy()
            new TomSelect(currentElement, {
                valueField: 'id', labelField: 'text', searchField: 'text', create: true, preload: 'focus',

                shouldLoad: function (query) {
                    return query.length > 1;
                },

                load: function (query, callback) {
                    var url2 = url + `&q=` + encodeURIComponent(query);
                    fetch(url2)
                        .then(response => response.json())
                        .then(json => {
                            callback(json.items);

                        }).catch(() => {
                        callback();
                    });
                },
            });
            currentElement.tomselect.refreshOptions()
            currentElement.tomselect.sync()
        } else {
            if (currentElement !== undefined && currentElement !== null && currentElement !== '' && currentElement.tagName === 'SELECT' && currentElement.tomselect !== undefined) {
                currentElement.tomselect.destroy()
                new TomSelect(currentElement, {
                    create: true, plugins: this.plugins,
                });
            }
        }
    }

    closeModal() {
        let checkboxes = this.CheckBoxs();
        let dataModal = this.DataModal()
        let selectElements = this.SelectedElements()
        let selectAllCheck = document.querySelectorAll('input[name="ungrouped_all_rows"]')
        checkboxes.forEach((checkbox) => {
            if (checkbox.checked === true) {
                checkbox.click()
            }
            if (selectAllCheck[0].checked === true) {
                selectAllCheck[0].click()
            }
        })

        selectElements.forEach((element) => {
            let selectedValue = element.value
            element.tomselect.removeItem(selectedValue)
            element.tomselect.sync()
        })
        dataModal.classList.add("hidden")
    }

    setUrl(selectedKeys, firstLevel, currentElement) {
        var url = new URL(document.getElementById("ungrouped_elements").dataset.url)
        let nextElement = this.setNextElement(currentElement)
        let childId = currentElement.getAttribute("child_id")
        let parentId = currentElement.getAttribute("parent_id")
        let parentElement = document.getElementById(parentId)
        // let filter = document.getElementById("ungrouped_filter")
        // if (filter !== null && filter !== undefined && filter !== '') {
        //     url.searchParams.set("filter", filter.value)
        // }
        if (nextElement !== null && nextElement !== '' && childId === nextElement.id) {
            url.searchParams.set("ancestors", selectedKeys)
        } else {
            if (parentElement.value !== '' && selectedKeys.length >= 1) {
                url.searchParams.set("ancestors", selectedKeys)
            }
        }

        url.searchParams.set("parent", firstLevel)
        return url.href
    }


    SelectedElements() {
        return document.getElementById('ungrouped_elements').querySelectorAll("select")
    }

    CheckBoxs() {
        return document.querySelectorAll('input[name="ungrouped_rows"]')
    }

    DataModal() {
        return document.getElementById("ungrouped_grouping_modal")
    }


    selectedKeys() {
        let selectedKeys = Array()
        let selectElements = this.SelectedElements()
        selectElements.forEach((element) => {
            if (element.value !== '') {
                selectedKeys.push(element.value)
            }
        })
        return selectedKeys
    }
}